import { createRouter, createWebHistory } from 'vue-router'
import { setPageTitle } from '@/utils/title'

// 路由懒加载组件，添加webpackChunkName注释进行代码分割
const HomePage = () => import(/* webpackChunkName: "home" */ '../pages/home/index.vue')
const CenterPage = () => import(/* webpackChunkName: "center" */ '../pages/center/index.vue')
const JoinPage = () => import(/* webpackChunkName: "join" */ '../pages/join/index.vue')
const GoodPage = () => import(/* webpackChunkName: "good" */ '../pages/good/index.vue')
const ToolPage = () => import(/* webpackChunkName: "tool" */ '../pages/tool/index.vue')
const LoginPage = () => import(/* webpackChunkName: "login" */ '../pages/login/index.vue')
const LoginCallbackPage = () => import(/* webpackChunkName: "login" */ '../pages/login/auth_callback.vue')
const RecordsPage = () => import(/* webpackChunkName: "records" */ '../pages/center/records/index.vue')
const WithdrawPage = () => import(/* webpackChunkName: "withdraw" */ '../pages/center/withdraw/index.vue')
const AddAccountPage = () => import(/* webpackChunkName: "addAccount" */ '../pages/center/addAccount/index.vue')
const AddPage = () => import(/* webpackChunkName: "add" */ '../pages/center/addAccount/add/index.vue')
const EditPage = () => import(/* webpackChunkName: "add" */ '../pages/center/addAccount/edit.vue')
const NoticesPage = () => import(/* webpackChunkName: "add" */ '../pages/center/notices/index.vue')
const NoticesInfoPage = () => import(/* webpackChunkName: "add" */ '../pages/center/notices/info.vue')
const ManagePage = () => import(/* webpackChunkName: "manage" */ '../pages/center/manage/index.vue')
const setUpPage = () => import(/* webpackChunkName: "setup" */ '../pages/setup/index.vue')
const WithdrawRecordPage = () => import(/* webpackChunkName: "withdraw" */ '../pages/center/withdraw/record.vue')
const ContactUsPage = () => import(/* webpackChunkName: "contactUs" */ '../pages/contactUs/index.vue')
const SocialCoefficientPage = () => import(/* webpackChunkName: "contactUs" */ '../pages/tool/social_coefficient.vue')
const GuidePage = () => import(/* webpackChunkName: "tool" */ '../pages/tool/guide.vue')
const BalanceRecordPage = () => import(/* webpackChunkName: "contactUs" */ '../pages/balance/record.vue')
const UserAgreementPage = () => import(/* webpackChunkName: "contactUs" */ '../pages/tool/user_agreement.vue')
const PrivacyAgreementPage = () => import(/* webpackChunkName: "contactUs" */ '../pages/tool/privacy_agreement.vue')

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: '青象传媒'
    },
    component: LoginPage
  },
  {
    path: '/home',
    name: 'Home',
    meta: {
      title: '青象传媒',
      requiresAuth: true
    },
    component: HomePage
  },
  {
    path: '/center',
    name: 'Center',
    meta: {
      title: '个人中心',
      requiresAuth: true
    },
    component: CenterPage,
  },
  {
    path: '/join',
    name: 'Join',
    meta: {
      title: '加入我们',
      requiresAuth: true
    },
    component: JoinPage
  },
  {
    path: '/good',
    name: 'Good',
    meta: {
      title: '优选资源',
      requiresAuth: true
    },
    component: GoodPage
  },
  {
    path: '/tool',
    name: 'Tool',
    meta: {
      title: '小工具',
      requiresAuth: true
    },
    component: ToolPage
  },
  {
    path: '/auth_callback',
    name: 'AuthCallback',
    meta: {
      title: '登录中',
      requiresAuth: false
    },
    component: LoginCallbackPage
  },
  {
    path: '/center/records',
    name: 'Records',
    meta: {
      title: '收入清单',
      requiresAuth: true
    },
    component: RecordsPage
  },
  {
    path: '/center/withdraw',
    name: 'Withdraw',
    meta: {
      title: '收入提现',
      requiresAuth: true
    },
    component: WithdrawPage
  },
  {
    path: '/center/addAccount',
    name: 'AddAccount',
    meta: {
      title: '直播账号',
      requiresAuth: true
    },
    component: AddAccountPage
  },
  {
    path: '/center/addAccount/add',
    name: 'Add',
    meta: {
      title: '添加直播账号',
      requiresAuth: true
    },
    component: AddPage
  },
  {
    path: '/center/addAccount/edit',
    name: 'Edit',
    meta: {
      title: '修改直播账号',
      requiresAuth: true
    },
    component: EditPage
  },
  {
    path: '/center/notices/index',
    name: 'Notices',
    meta: {
      title: '消息通知',
      requiresAuth: true
    },
    component: NoticesPage
  },
  {
    path: '/center/notices/info',
    name: 'NoticesInfo',
    meta: {
      title: '消息通知详情',
      requiresAuth: true
    },
    component: NoticesInfoPage
  },
  {
    path: '/center/manage',
    name: 'Manage',
    meta: {
      title: '艺人管理',
      requiresAuth: true
    },
    component: ManagePage
  },
  
  {
    path: '/setup/index',
    name: 'Setup',
    meta: {
      title: '设置',
      requiresAuth: true
    },
    component: setUpPage
  },
  {
    path: '/withdraw/record',
    name: 'WithdrawRecord',
    meta: {
      title: '提现记录',
      requiresAuth: true
    },
    component: WithdrawRecordPage
  },
  {
    path: '/contactUs',
    name: 'ContactUs',
    meta: {
      title: '联系我们',
      requiresAuth: true
    },
    component: ContactUsPage
  },{
    path: '/social_coefficient',
    name: 'socialCoefficient',
    meta: {
      title: '社交系数计算',
      requiresAuth: true
    },
    component: SocialCoefficientPage
  },
  {
    path: '/guide',
    name: 'Guide',
    meta: {
      title: '操作指南',
      requiresAuth: true
    },
    component: GuidePage
  },
  {
    path: '/balance_record',
    name: 'BalanceRecord',
    meta: {
      title: '余额记录',
      requiresAuth: true
    },
    component: BalanceRecordPage
  },
  {
    path: '/user_agreement',
    name: 'UserAgreement',
    meta: {
      title: '用户协议',
	  showFooter: false  // 显示底部菜单
    },
    component: UserAgreementPage
  },
  {
    path: '/privacy_agreement',
    name: 'PrivacyAgreement',
    meta: {
      title: '隐私协议',
  	  showFooter: false  // 显示底部菜单
    },
    component: PrivacyAgreementPage
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 添加路由懒加载的错误处理
router.onError((error) => {
  console.error('路由加载失败:', error)
  // 可以在这里添加全局错误处理逻辑
})

// 检查用户是否已登录
function isAuthenticated() {
  return !!localStorage.getItem('token')
}

// 路由守卫：检查登录状态和设置页面标题
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta && to.meta.title) {
    setPageTitle(to.meta.title)
  } else {
    setPageTitle('青象传媒')
  }

  // 检查是否需要认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 需要认证的路由，检查token
    if (!isAuthenticated()) {
      // 没有token，跳转到登录页面
      next({
        path: '/login',
        query: { redirect: to.fullPath } // 保存要访问的页面路径
      })
      return
    }
  }

  // 如果访问登录页面但已登录，跳转到首页
  // if (to.path === '/login' && isAuthenticated()) {
  //   console.log('用户已登录，跳转到首页')
  //   next('/home')
  //   return
  // }

  next()
})

export default router
